import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { SharedModule } from "@bb-vendure/admin-ui/core";

@Component({
  selector: "custom-customer-label",
  imports: [SharedModule],
  standalone: true,
  templateUrl: "./custom-customer-label.component.html",
  styleUrls: ["./custom-customer-label.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CustomCustomerLabelComponent {
  @Input() customer: any;
}
